import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MEAPIService } from 'src/app/common/services/api/me-api.service';

@Injectable()
export class XsrfInterceptor implements HttpInterceptor {

  constructor(private srvApi: MEAPIService) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    let headers = this.srvApi.getHttpHeaders();
    let url = this.srvApi.appendUrl(req.url);
    req = req.clone({ url, headers });

    return next.handle(req);
  }

}